import * as _ from 'lodash';
import { FormControl, FormGroup, Label, Table } from 'react-bootstrap';
import styled from 'styled-components';
import { IRequiredField } from './models/index';

const TableWrapper = styled(Table)`
    & > thead > tr > th {
        text-align: center;
    }

    & > tbody > tr > td {
        vertical-align: middle;
        text-align: center;
    }
`;

interface IProps {
    headers: string[],
    sampleRow: string[],
    requiredFields: IRequiredField[],
    mappedFields: string[],
    hasColumnHeaders: boolean,
    isDirty: boolean,
    onMappingChange: (mappedFields: string[]) => void
}

const ColumnMapping = (props: IProps) => {
    const handleFieldChange = (index: number, field: string) => {
        let mappedFields = [...props.mappedFields];
        mappedFields[index] = field;

        props.onMappingChange(mappedFields);
    };

    const sortedHeaders = props.hasColumnHeaders ? _.orderBy(props.headers, header => header) : _.range(1, props.sampleRow.length + 1).map(f => f.toString());

    return (
        <>
            <TableWrapper condensed bordered>
                <thead>
                    <tr>
                        <th style={{ width: '25%' }}>Required Column</th>
                        <th>First Row of Data</th>
                        <th>Column From File</th>
                    </tr>
                </thead>
                <tbody>
                    {props.requiredFields.map((field, index) => {
                        let mappedField = props.mappedFields[index];
                        let sampleData = null;

                        if (mappedField != '') {
                            sampleData = props.hasColumnHeaders ? props.sampleRow[props.headers.indexOf(mappedField)] : props.sampleRow[parseInt(mappedField) - 1];

                            if (sampleData == '') {
                                sampleData = <Label style={{ fontSize: '100%' }}>No Sample Data</Label>;
                            }
                        } else {
                            sampleData = <Label style={{ fontSize: '100%' }}>Pending Selection =&gt;</Label>;
                        }

                        return (
                            <tr>
                                <td>{props.hasColumnHeaders ? field.fieldName : 'Column ' + (index + 1)}</td>
                                <td>{sampleData}</td>
                                <td>
                                    <FormGroup style={{ marginBottom: 0 }} validationState={props.isDirty && mappedField == '' ? 'error' : null}>
                                        <FormControl
                                            componentClass='select'
                                            value={mappedField}
                                            onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => handleFieldChange(index, e.currentTarget.value)}
                                        >
                                            <option value=''>- Assign Column -</option>
                                            {sortedHeaders.map(header =>
                                                <option value={header}>{header}</option>
                                            )}
                                        </FormControl>
                                    </FormGroup>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </TableWrapper>
        </>
    );
}

export default ColumnMapping;